import React from "react";
import { Button, Card } from "react-bootstrap";
import "../../styles/components/TransactionSummary.scss";
import TransactionSummaryRow from "../TransactionSummaryRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilesMedical } from "@fortawesome/pro-solid-svg-icons";

const TransactionSummary = (props) => {
  const data = props.data1;
  // const coreOut = data["Core-Out"];
  const tData = props.transdata;
  let total = 0;
  Object.entries(tData).map(([key, value]) => (total += value.Total));
  return (
    <>
      <div className="mapper-profile">
        <div
          className="header my-flex"
          style={{ padding: "0.5rem", display: "flex" }}
        >
          <FontAwesomeIcon
            icon={faFilesMedical}
            style={{ color: "#0758e4", fontSize: "20px" }}
          />
          <h5
            style={{
              fontWeight: "600",
              fontSize: "1.1rem",
              marginBottom: "0",
              marginRight: "48.5rem",
            }}
          >
            Transaction
          </h5>
          <p>
            <strong style={{ fontSize: "1rem" }}>{total} </strong>
            <span className="light-text" style={{ fontSize: "1rem" }}>
              {" "}
              / Total No. Active Profile{" "}
            </span>
          </p>
        </div>
        <div style={{ margin: "8px ", fontWeight: "600", fontSize: "1.1rem" }}>
          <h5 style={{ "font-weight": "700", "font-size": "17px" }}>
            Transaction summary
          </h5>
        </div>
        <div style={{ width: "60%" }}>
          <TransactionSummaryRow data={tData} />
        </div>
      </div>
    </>
  );
};

export default TransactionSummary;
